import React from 'react';
import { ShouldRender } from '../../../ui-core/ShouldRender';
import PropTypes from 'prop-types';
import LazyImage from '../../../ui-core/Image';
import { IMAGE_CONSTANT } from '../../../constants/app';
// import parser from 'html-react-parser';
import { formatCurrency } from '../../../utils/helpers';
import { getItem, setItem } from '../../../utils/cache';
import { useDispatch } from 'react-redux';
import { AddOfflineCartData } from '../../../store/action/checkout';

const OfflineCartItem = ({ selectedProducts }) => {
  const dispatch = useDispatch();
  const localCartData = JSON.parse(getItem('offlineCart') || []);
  const OfflineCartData = selectedProducts?.map(item => {
    if (item?.attributes) {
      return {
        ...item.attributes,
        id: item.id,
      };
    } else {
      return {
        ...item,
        title: item.name,
      };
    }
  });

  const handleRemove = id => {
    const newOfflineCartData = localCartData?.filter(item => {
      return +item.id !== +id;
    });
    setItem('offlineCart', JSON.stringify(newOfflineCartData));
    dispatch(AddOfflineCartData(newOfflineCartData));
  };

  return (
    <React.Fragment>
      <ShouldRender check={true}>
        {OfflineCartData.map(item => (
          <div className="checkout-card mb-4 pb-4" key={item.id}>
            <LazyImage
              alt={item?.title}
              className={!item?.thumbnail ? 'jen-logo' : undefined}
              errorSrc={IMAGE_CONSTANT.placeholderImage}
              placeholderSrc={IMAGE_CONSTANT.placeholderImage}
              src={item?.thumbnail || '/Logo.png'}
            />
            <div className="card-detail">
              <div className="d-flex justify-content-between">
                <h4>{item?.title}</h4>
              </div>
              {/* <ShouldRender check={!!item?.description}>
                <p>{parser(item?.description || '')}</p>
              </ShouldRender> */}
              <div className="d-flex mt-2 gap-2">
                <ShouldRender
                  check={
                    OfflineCartData?.length >= 2 &&
                    OfflineCartData?.[0]?.bundle_and_save === true
                  }
                >
                  <div className="price-cut">
                    {formatCurrency(+item?.amount / 100, item?.currency, 2)}
                  </div>
                </ShouldRender>
                <div className="currency-amt">
                  {OfflineCartData?.[0]?.bundle_and_save === true
                    ? formatCurrency(
                        OfflineCartData?.length === 2
                          ? (+item?.amount - +item?.amount * (20 / 100)) / 100
                          : OfflineCartData?.length === 3
                          ? (+item?.amount - +item?.amount * (30 / 100)) / 100
                          : OfflineCartData?.length >= 4
                          ? (+item?.amount - +item?.amount * (40 / 100)) / 100
                          : +item?.amount / 100,
                        item?.currency,
                        2,
                      )
                    : formatCurrency(+item?.amount / 100, item?.currency, 2)}
                </div>
              </div>
            </div>
            <div className="remove-deal" onClick={() => handleRemove(item?.id)}>
              <img src={IMAGE_CONSTANT.deleteIcon} alt="remove deal" />
            </div>
          </div>
        ))}
      </ShouldRender>
    </React.Fragment>
  );
};

OfflineCartItem.propTypes = {
  selectedProducts: PropTypes.array,
};

export default OfflineCartItem;
